// extracted by mini-css-extract-plugin
module.exports = {"policy":"cj_b2","underline":"cj_b3"};